import { Component } from '@angular/core';
import { PriceListsPortalComponent } from '../pricelists-portal/pricelists-portal.component';

@Component({
  standalone: true,
  imports: [PriceListsPortalComponent],
  selector: 'lx-price-lists-portal-row-price-lists-portal',
  templateUrl: './row-pricelists-portal.component.html',
  styleUrls: ['./row-pricelists-portal.component.scss'],
})
export class RowPriceListsPortalComponent {}
